import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';

interface BadgeButtonProps {
  count: number;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  icon: IconDefinition;
  variant?: 'error' | 'pending';
}

const BadgeButton: React.FC<BadgeButtonProps> = ({
  count,
  onClick,
  icon,
  variant = 'error',
}) => (
  <button
    type="button"
    className="p-menuitem-link integration-errors-menuitem"
    onClick={onClick}
  >
    <span className="integration-errors-icon-wrapper">
      <FontAwesomeIcon
        icon={icon}
        className="p-menuitem-icon integration-errors-menuitem-icon"
      />
      {count > 0 && (
        <span
          className={`integration-errors-badge integration-errors-badge--${variant}`}
        >
          {count}
        </span>
      )}
    </span>
  </button>
);

export default BadgeButton;
